module.exports = __webpack_public_path__ + "static/media/amber-tamir.d2415b9a.jpg";